export default __webpack_public_path__ + "static/media/Band_2_Beat.8ca26aeb.mp4";